import React, { Component, Fragment } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import URC from 'ui-react-common';
import Loadable from 'react-loadable';
import SVG from 'react-inlinesvg';
import ApplicationPage from '../pages/application-page/Application';
import WrappedApplicationPage from '../pages/wrapped-application-page/WrappedApplicationPage';
import { PrivateRoute } from '../components/routing';
import ProdConfig from '../components/prod-config/ProdConfig';
import PIIRetryPage from '../pages/pii-retry-page/PIIRetryPage';
import Masthead from '../components/masthead/Masthead';
import ChatScript from '../components/chat-script/ChatScript';
import {
    errorRoute,
    mapping
} from '../components/routing/routing-servercodes-mapping';
import '../../node_modules/ui-sdk/source/images/D-SparkCoreIcons.svg';
import config from '../config';
import rocketMortgageLogo from '../../node_modules/ui-sdk/source/images/L-RocketMortgage-RGB-Horz-Inv.svg';
import rocketHomesLogo from '../../node_modules/ui-sdk/source/images/L-RocketHomes-RGB-Horz-Inv.svg';
import rocketMoneyLogo from '../../node_modules/ui-sdk/source/images/L-RocketMoneyLogo.svg';
import EHOLogo from '../../node_modules/ui-sdk/source/images/EHOLogo.png';
import sparkIcons from '../../node_modules/ui-sdk/source/images/D-SparkCoreIcons.svg';
import facebookLogo from '../../node_modules/ui-sdk/source/images/facebook.svg';
import twitterLogo from '../../node_modules/ui-sdk/source/images/twitter.svg';
import instagramLogo from '../../node_modules/ui-sdk/source/images/instagram.svg';
import mailLogo from '../../node_modules/ui-sdk/source/images/email.svg';
const { AppFooter } = URC.ui.components;
const { baseName } = config;


const OffersPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "offerspage" */ '../pages/offers-page/OffersPage'),
    loading: () => null,
});

const RegistrationPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "registrationpage" */ '../pages/registration-page/RegistrationPage'),
    loading: () => null,
});

const CreditFreezePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "creditfreezepage" */ '../pages/credit-freeze-page/CreditFreeze'),
    loading: () => null,
});

const PageNotFoundPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "pagenotfoundpage" */ '../pages/page-not-found-page/PageNotFoundPage'),
    loading: () => null,
});

const ServerErrorPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "servererrorpage" */ '../pages/server-error-page/ServerErrorPage'),
    loading: () => null,
});

const FraudErrorPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "frauderrorpage" */ '../pages/fraud-error-page/FraudErrorPage'),
    loading: () => null,
});

const AccountExistsPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "accountexistspage" */ '../pages/account-exists-page/AccountExistsPage'),
    loading: () => null,
});

const LeadRegisterPage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "leadregisterpage" */ '../pages/lead-register-page/LeadRegisterPage'),
    loading: () => null,
});

const LeadCompletePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "leadcompletepage" */ '../pages/lead-complete-page/LeadCompletePage'),
    loading: () => null,
});

const EmailInUsePage = Loadable({
    loader: () =>
        import(/* webpackChunkName: "emailinusepage" */ '../pages/email-in-use-page/EmailInUsePage'),
    loading: () => null,
});

const { ScrollToTop } = URC.ui.containers;
const { RoutingSubscriber } = URC.ui.containers.routingSubscriber;
const { webUIRoot, webUIUrl } = config;

class ApplicationFlowRouter extends Component {
    constructor(props) {
        super(props);
        this.checkAndUpdateBadHashLinks();
    }

    checkAndUpdateBadHashLinks() {
        // redirect pages without pattern index.html#
        const { hash, href, search } = window.location;
        if (!hash || !href.includes('index.html#')) {
            // Redirect to the known page with the hash
            window.location.href = `/inq/index.html#/${search}`;
        }
    }

    render() {
        return (
            <BrowserRouter basename={baseName}>
                <RoutingSubscriber routerMapping={mapping} errorRoute={errorRoute}>
                    <Fragment key="appContainer">
                        <ScrollToTop>
                            <Masthead />
                            <Switch>
                                <Route exact path="/" component={ApplicationPage} />
                                <Route exact path="/rocketaccountapply" component={WrappedApplicationPage} />
                                <PrivateRoute path="/pii" component={PIIRetryPage} />
                                <PrivateRoute path="/offers" component={OffersPage} />
                                <PrivateRoute path="/leadcomplete" component={LeadCompletePage} />
                                <PrivateRoute path="/emailinuse" component={EmailInUsePage} />
                                <PrivateRoute path="/register" component={RegistrationPage} />
                                <PrivateRoute path="/leadregister" component={LeadRegisterPage} />
                                <PrivateRoute path="/credit-freeze" component={CreditFreezePage} />
                                <Route path="/contact-us" component={ServerErrorPage} />
                                <Route path="/cannot-process" component={FraudErrorPage} />
                                <Route path="/account-exists" component={AccountExistsPage} />
                                <Route component={PageNotFoundPage} />
                            </Switch>
                            <AppFooter
                                appRoot={webUIRoot}
                                appUrl={webUIUrl}
                                rocketMortgageLogo={rocketMortgageLogo}
                                rocketHomesLogo={rocketHomesLogo}
                                rocketMoneyLogo={rocketMoneyLogo}
                                EHOLogo={EHOLogo}
                                facebookLogo={facebookLogo}
                                twitterLogo={twitterLogo}
                                instagramLogo={instagramLogo}
                                mailLogo={mailLogo}
                            />
                            <SVG
                                src={sparkIcons}
                                uniquifyIDs={false}
                            />
                            <ProdConfig />
                            <ChatScript config={config.five9Config} />
                        </ScrollToTop>
                    </Fragment>
                </RoutingSubscriber>
            </BrowserRouter>
        );
    }
}

export default ApplicationFlowRouter;
